import { useEffect, useState } from "react";
import api from "@/lib/api";
import { criteria } from "@/components/AlertsPanel";

const Top = ({ title, rows, testid }) => (
  <div className="bg-white border border-gray-200 p-5" data-testid={testid}>
    <h3 className="text-xs uppercase tracking-wider text-[#475569]">{title}</h3>
    <ul className="mt-3 space-y-2">
      {rows.length === 0 && <li className="text-sm text-gray-400">—</li>}
      {rows.map(([k, n]) => {
        const max = rows[0][1];
        return (
          <li key={k} className="text-sm">
            <div className="flex justify-between gap-3"><span className="text-[#1B2A4A] truncate">{k}</span><strong className="text-[#1B2A4A]">{n}</strong></div>
            <div className="h-1.5 bg-gray-100 mt-1"><div className="h-full bg-[#E0C173]" style={{ width: `${(n / max) * 100}%` }} /></div>
          </li>
        );
      })}
    </ul>
  </div>
);

export default function AdminAlertsPanel() {
  const [data, setData] = useState({ items: [], active: 0, top_sectors: [], top_regions: [] });
  useEffect(() => { api.get("/admin/alerts").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="admin-alerts-panel">
      <p className="text-sm text-[#475569]" data-testid="admin-alerts-count">{data.items.length} alerte(s) · {data.active} active(s). Chaque nouvelle annonce publiée est envoyée automatiquement aux repreneurs dont les critères correspondent.</p>
      <div className="grid md:grid-cols-2 gap-6">
        <Top title="Secteurs les plus recherchés" rows={data.top_sectors} testid="admin-alerts-top-sectors" />
        <Top title="Régions les plus recherchées" rows={data.top_regions} testid="admin-alerts-top-regions" />
      </div>
      <div className="bg-white border border-gray-200 overflow-x-auto">
        {data.items.length === 0 ? <p className="text-gray-400 py-10 text-center text-sm">Aucune alerte créée par les repreneurs.</p> : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-[#475569]">
              <tr><th className="p-3">Repreneur</th><th className="p-3">Alerte</th><th className="p-3">Critères</th><th className="p-3">Emails</th><th className="p-3">Statut</th></tr>
            </thead>
            <tbody>
              {data.items.map((a) => (
                <tr key={a.alert_id} data-testid={`admin-alert-${a.alert_id}`} className="border-t border-gray-100 align-top">
                  <td className="p-3 min-w-[180px]"><div className="text-[#1B2A4A] font-medium">{a.user?.name || "—"}</div><div className="text-xs text-[#475569] break-all">{a.user?.email}</div>{a.user?.phone && <div className="text-xs text-[#475569]">{a.user.phone}</div>}</td>
                  <td className="p-3 text-[#1B2A4A]">{a.name || "—"}</td>
                  <td className="p-3 text-[#475569] min-w-[240px]">{criteria(a)}</td>
                  <td className="p-3 text-[#475569]">{a.sent_count || 0}</td>
                  <td className="p-3"><span className={`text-xs px-2 py-1 ${a.active ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>{a.active ? "Active" : "En pause"}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
